import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'caaks-dropdown-multi-select',
  templateUrl: './dropdown-multi-select.component.html',
  styleUrl: './dropdown-multi-select.component.scss',

  standalone: false,})
export class DropdownMultiSelectComponent {
  @Input() items: { id: string; name: string }[];
  @Output() selectItemsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

  private selectedItems: string[] = [];

  public selectItem(item: { id: string; name: string }) {
    if (this.selectedItems.includes(item.id)) {
      this.selectedItems = this.selectedItems.filter(e => e !== item.id);
    } else {
      this.selectedItems.push(item.id);
    }
    this.selectItemsChanged.next(this.selectedItems);
  }
}
